import { api } from '../api.js';

export async function renderForgotPasswordPage({ root }) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="forgot-form">
        <h1>Забыл пароль?</h1>
        <p class="text-muted text-center" style="margin-top: -14px; margin-bottom: 20px;">
          Введи email — кинем на него ссылку для сброса.
        </p>
        <div class="form-error" id="form-error"></div>
        <div class="success-note" id="success-note" style="display: none;">
          Если такой email у нас есть — ссылка полетела. Проверь почту (и папку «Спам»).
        </div>
        <div class="field">
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required autocomplete="email" />
        </div>
        <div class="actions">
          <button type="submit" id="submit-btn">Прислать ссылку</button>
        </div>
        <div class="alt">
          Вспомнил? <a href="/login" data-link>Войти</a>
        </div>
      </form>
    </div>
  `;
  const form = root.querySelector('#forgot-form');
  const errEl = root.querySelector('#form-error');
  const note = root.querySelector('#success-note');
  const btn = root.querySelector('#submit-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    btn.disabled = true;
    try {
      await api.auth.forgot(form.email.value);
      note.style.display = 'block';
      btn.textContent = 'Готово, проверь почту';
    } catch (err) {
      errEl.textContent = err.message || 'Не удалось отправить — попробуй ещё раз';
      btn.disabled = false;
    }
  });
}
